module.exports = {"pathContext":{"title":"China’s coming Austrian collapse","createdAt":"14 hours ago","by":"Zweihander","comments":[{"text":"There might be truth to this article but its bias and demeaning tone are off-putting. It makes it hard to take the author seriously.","by":"ahmedalsudani","timeISO":"7 hours ago"}]}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/comment-17770230.json
// module id = 911
// module chunks = 200000886538636